import { render, staticRenderFns } from "./AboutUsPage.vue?vue&type=template&id=02d95ac9&scoped=true&"
import script from "./AboutUsPage.vue?vue&type=script&lang=js&"
export * from "./AboutUsPage.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsPage.vue?vue&type=style&index=0&id=02d95ac9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d95ac9",
  null
  
)

export default component.exports